import WindowedModalV2 from "designer/modals-v2/windowed-modal/windowed-modal";
import ActionModal from "../../smart/action-modal/action-modal";
import { GlideFC } from "lib/glide-fc";

interface ThirdPartyCookiesModalProps {
    resolve(): void;
}

export const ThirdPartyCookiesModal: GlideFC<ThirdPartyCookiesModalProps> = props => {
    return (
        <WindowedModalV2 canClose={false} onClose={props.resolve} hideClosingButton={true}>
            <ActionModal
                header="Cookies not enabled"
                description="Your browser is currently blocking 3rd party cookies. Please enable 3rd party cookies for Glide to continue."
                acceptText="OK"
                acceptAction={props.resolve}
            />
        </WindowedModalV2>
    );
};
